import*as React from"react";import styled from"@emotion/styled";import{StyledForm,StyledFormItem}from"@wp/src/components/screenComponents/onboarding/userAccountOnboardingStyledComponents";import Divider from"@wp/src/components/common/divider";import{FlexLayout,Modal,Drawer,AntdSelect}from"@wp/src/components/common";import FormInput from"@wp/src/components/common/input/Input";export const AccountSetupFormInout=styled(FormInput)`
  min-width: 270px;
`;export const AccountSetupDrawer=styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
  }
`;export const AccountSetupForm=styled(StyledForm)`
  flex: 1;
  padding: 0;
`;export const AccountSetupFormItem=styled(StyledFormItem)`
  .ant-form-item-label {
    padding-bottom: 4px;
  }
`;export const FormContainer=styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  height: 100%;
  .ant-form-item {
    margin-bottom: 0;
  }
`;export const ActionsContainer=styled(FlexLayout)`
  margin: auto 0 0 0;
  justify-content: flex-end;
  width: 100%;
  border-top: 1px solid ${props=>props.theme.colors.neutral200};
  padding-top: 16px;
`;export const Label=styled.div`
  margin-bottom: 4px;
`;export const SubAccountsHeading=styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${props=>props.theme.colors.neutral900};
  margin: 24px 0 16px 0;
`;export const StyledDivider=styled(Divider)`
  margin: 0 0 16px 0;
`;export const StyledInfoDescription=styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${props=>props.theme.colors.neutral500};
`;export const StyledAccountProviderConnectStatusModal=styled(Modal)`
  .ant-modal-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
`;export const StyledConnectProviderContainer=styled.div`
  & > div {
    max-height: calc(var(--vh, 1vh) * 60);
  }
`;export const AdvisorFeeHelperMessage=()=>React.createElement("div",null,React.createElement("div",null,"(in percent, e.g. enter 1% as 1 or 25bp as .25)"),React.createElement("div",null,"Required for fee estimation"));export const AccountTypeStyledSelect=styled(AntdSelect)``;